import React from 'react';
import {Grid, InputAdornment, IconButton} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/Visibility'
import { TextField } from '@mui/material';

export const Input = ({name, handleChange, label, autoFocus, type, half, handleShowPassword}) => {
  return (
    <Grid item xs={12} sm={half ? 6 : 12}>
        <TextField 
            name={name} 
            onChange={handleChange} 
            variant="outlined" 
            required 
            fullWidth 
            label={label} 
            autoFocus={autoFocus} type={type}
            InputProps={name === 'password' ? {
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton onClick={handleShowPassword}>
                            {type === 'password' ? <Visibility/> : <VisibilityOff/>}
                        </IconButton>
                    </InputAdornment>
                )
            } : null }
            />
    </Grid>
  );
};
